import type { FC } from 'react'

import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { formatNumber } from '@/lib/format'
import { revealDelay } from '@/lib/motion'
import { Photo } from '@/components/generals/photo'
import { ButtonLink } from '@/components/generals/button'

import { CAKE_RULES, SHELL } from '@/constants/site'

export const CakesTeaser: FC = () => (
    <section id='custom-cakes' aria-labelledby='cakes-title' className='relative overflow-hidden lg:h-[46rem]'>
        {/* Mirrored on large screens so the cake sits opposite the right-aligned text. */}
        <Photo
            src='/images/menu/vanilla-raspberry-sponge.jpg'
            alt='برشی از کیک اسفنجی وانیلی لایه‌لایه با یک تمشک روی آن، در نور ملایم عصر'
            sizes='100vw'
            className='aspect-[4/3] sm:aspect-[16/9] lg:absolute lg:inset-0 lg:aspect-auto lg:rtl:-scale-x-100'
            position='72% 45%'
        />

        <div className={cn(SHELL, 'relative py-14 lg:flex lg:h-full lg:items-center lg:py-0')}>
            <div className='max-w-md'>
                <p className='label-caps text-crust-soft' data-reveal='up'>کیک سفارشی</p>

                <h2 id='cakes-title' className='mt-4 font-heading text-[2.75rem] leading-[1.2] font-normal tracking-[-0.01em] sm:text-6xl lg:text-[4.5rem]' data-reveal='up' style={revealDelay(80)}>
                    کیک برای روزهایی <span className='italic'>که ماندنی‌اند</span>
                </h2>

                <p className='mt-6 text-[1.0625rem] leading-relaxed text-crust-soft lg:text-foreground/80' data-reveal='up' style={revealDelay(160)}>
                    تولد، عروسی و سالگردهای دونفره. از مناسبت و طعم‌هایی که دوست دارید برایمان بگویید تا کیکی درخور همان روز بپزیم. فقط کافی است دست‌کم {formatNumber(CAKE_RULES.leadDays * 24)} ساعت زودتر خبرمان کنید.
                </p>

                <div data-reveal='up' style={revealDelay(240)}>
                    <ButtonLink href='/custom-cakes' className='mt-8'>
                        درخواست کیک سفارشی
                        <ArrowRight className='size-4 transition-transform duration-500 ease-(--ease-soft) rtl:-scale-x-100 group-hover/button:translate-x-0.5 rtl:group-hover/button:-translate-x-0.5' aria-hidden='true' />
                    </ButtonLink>
                </div>
            </div>
        </div>
    </section>
)
